import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Spinner,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";

const InstructorReviewDetails = () => {
  const { instructorId, id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseItem = "";
    try {
      responseItem = await axios.get(`/instructor-reviews/${id}`);
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  return result ? (
    <Page
      narrowWidth
      backAction={{
        onAction: () => navigate(`/admin/instructors/${instructorId}/reviews`),
      }}
      title={`Review Details`}
    >
      <Card>
        <FormLayout>
          <FormLayout.Group condensed>
            <Text>
              <b>Title</b>
              <br /> {result?.title ? result?.title : "-"}
            </Text>
            <Text>
              <b>Description</b>
              <br />
              {result?.description ? result?.description : "-"}
            </Text>
            <Text>
              <b>Created at</b>
              <br />
              {result?.created_at
                ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </Text>
          </FormLayout.Group>
          <FormLayout.Group condensed>
            <Text>
              <b>Instructor</b>
              <br />
              {result?.instructor && result?.instructor?.name
                ? result?.instructor?.name
                : "-"}
            </Text>
            <Text>
              <b>Rating</b>
              <br />
              {result?.rating !== null ? result?.rating : "-"}
            </Text>
            <Text></Text>
          </FormLayout.Group>
        </FormLayout>
      </Card>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default InstructorReviewDetails;
